<script>
    import { fade } from 'svelte/transition';
    import yup, { string } from 'yup';
    import { validateForm } from '../Form/utils.js';
    import { submit } from '../../utils.js';
    import {onMount} from 'svelte';
    import { PATH_PREFIX, PATH_PREFIX_ABS } from '../../apiUrls';


    export let allowSSO;
    export let loginUrl;
    export let ssoUrl;

    let isSSO = allowSSO;
    let sending = false;

    let credentials = {
        username: '',
        password: '',
    };

    let fieldValidations = {};

    // No translation required for local dev page
    const loginSchema = yup.object().shape({
        username: yup.string().required('Required Field'),
        password: yup.string().required('Required Field'),
    });

    function handleKeyDown(event) {
        if (event.keyCode == 13 && !isSSO) {
            handleLogin();
        }
    }

    async function handleLogin() {
        try {
            await validateForm(loginSchema, credentials);
            sending = true;
            const resp = await submit(loginUrl, 'POST', credentials);
            const response = await resp.json();

            if (resp.ok) {
                location.reload();
            } else {
                fieldValidations = response;
                sending = false;
            }
        } catch (errors) {
            console.error(errors);
            if (errors.inner) {
                errors.inner.forEach((er) => {
                    fieldValidations[er.path] = er.message;
                });
            }
            sending = false;
        }
    }

    function selectEmployeeLogin() {
        isSSO = true;
    }

    function selectAdminLogin() {
        isSSO = false;
    }

    onMount(() => {
        if(isSSO && allowSSO){
            window.location.replace(`${window.location.protocol}//${window.location.host}${ssoUrl}`);
        }
    });
</script>

<style>
    #login-form {
        z-index: 1002;
    }

    #login-header {
        border-radius: 10px 10px 0px 0px;
    }

    #login-footer {
        border-radius: 0px 0px 10px 10px;
    }

    .active-tab {
        border-bottom: 4px solid #DD5900;
    }

    a:hover {
        cursor: pointer;
    }

</style>

<svelte:window on:keydown={handleKeyDown} />

<div id="login-form" class="text-center">
    <div id="login-header" class="pt-5 px-5 bg-white border-bottom">
        <div class="d-flex pb-5 px-3 justify-content-center align-items-center">
            <img class="mr-2" style="width: 100px;" src="http://localhost:8000{PATH_PREFIX_ABS}sw/static/common/libs/sw-web-components/images/bhp-logo.svg" />
            <div class="d-block text-left">
                <h5 class="mb-0">Standardised Work</h5>
            </div>
        </div>

    </div>
    <div id="login-footer" class="p-5 bg-gray-200">
        <div class="px-3 align-items-center">
            {#if !allowSSO && !isSSO}
                <div in:fade class="">
                    <form method="POST">
                        <input type="hidden" name="csrfmiddlewaretoken" value="">
                        {#if 'error' in fieldValidations}
                            <div class="error">
                                <p class="text-danger">{fieldValidations.error}</p>
                            </div>
                        {/if}
                        <div class="form-group">
                            <input type="text" name="username" class="form-control {'username' in fieldValidations ? 'is-invalid' : ''}" placeholder="Username" bind:value={credentials.username}>
                        </div>
                        <div class="form-group">
                            <input type="password" name="password" class="form-control {'password' in fieldValidations ? 'is-invalid': ''}" placeholder="Password" bind:value={credentials.password}>
                        </div>
                        <button class="btn btn-primary form-control login-button" class:disabled={sending} type="button" on:click|preventDefault={handleLogin}>
                            Log In
                            {#if sending}
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">sending</span>
                            </div>
                            {/if}
                        </button>
                    </form>
                </div>
            {/if}
        </div>
    </div>
</div>
